import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateChatAgentInstructionsInput,
  UpdateChatAgentInstructionsMutation as UpdateChatAgentInstructionsMutationResult,
} from '@/gql/graphql';

const UpdateChatAgentInstructionsMutation = graphql(`
  mutation UpdateChatAgentInstructions(
    $input: UpdateChatAgentInstructionsInput!
  ) {
    updateChatAgentInstructions(input: $input) {
      id
      chatAgentInstructions
    }
  }
`);

export const useUpdateChatAgentInstructions = (args?: {
  options?: UseMutationOptions<
    UpdateChatAgentInstructionsMutationResult,
    Error,
    UpdateChatAgentInstructionsInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: UpdateChatAgentInstructionsInput) => {
      return gqlClient.request(UpdateChatAgentInstructionsMutation, { input });
    },
    onSuccess: async (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountSettings(),
      });
      await onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUpdateChatAgentInstructions;
